import { useToastNotifications } from './useToastNotifications';

interface HandleErrorsOptions {
  message: string;
  logToConsole?: boolean;
  logToSentry?: boolean;
  showToast?: boolean;
  toastDetail?: string;
  autoDismissToast?: boolean;
}

const defaultOptions: Partial<HandleErrorsOptions> = {
  logToConsole: true,
  logToSentry: false,
  showToast: true,
  autoDismissToast: true,
};

export const useHandleError = () => {
  const { DEFAULT_LIFETIME, showError } = useToastNotifications();
  return {
    handleError: (options: HandleErrorsOptions) => {
      const opts = { ...defaultOptions, ...options };

      if (opts.logToConsole) {
        console.error(opts.message);
      }

      if (opts.logToSentry) {
        // TODO
      }

      if (opts.showToast) {
        showError(opts.toastDetail ?? opts.message, opts.message, DEFAULT_LIFETIME, opts.autoDismissToast);
      }
    },
  };
};
